import styles from "./image.module.less";
import { SimiulatorEquipment } from "@/types/equipment"
import { ImageNozzle } from "./Nozzle"
import { GraphAttributes } from "@/types/common"
import { SvgElem } from "@/components/SvgElem/SvgElem"
import { mm2px } from "@/utils/size"

interface EquipmentImageProps {
  equipment: SimiulatorEquipment
  editLayout?: GraphAttributes
}

export const EquipmentImage = (props: EquipmentImageProps) => {
  const { equipment } = props
  const nozzles = equipment.nozzles
  const imgW = mm2px(equipment.width);
  const imgH = mm2px(equipment.height)
  const boxStyles = {
    width: imgW,
    height: imgH
  }


  const nozzleElems = nozzles
    .filter(item => item.autoLayout === undefined)
    .map((item) => {
      return <ImageNozzle equipHeight={imgH} equipWidth={imgW} nozzle={item} key={item.id} />
    })

  const containerW = imgW + 20;
  const containerH = imgH + 20;

  return <div className={styles.container} style={{width: containerW, height: containerH}}>
    <div className={styles.image} style={boxStyles}>
      {/* <img src={svgStrToDataUrl(equipment.image)} alt="" className="svg-image" /> */}
      <SvgElem imageStr={equipment.image} className="svg-image" />
      {nozzleElems}
    </div>
  </div>
}